import { OutlinedSelect } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Card, Col } from 'reactstrap';

import BaseLoader from './parts/BaseLoader';
import { FilterList } from './parts/PeriodsSelector';
import TuitionContinuityProcessManagementList from './parts/TuitionContinuityProcessManagementList';
import { TuitionContinuityProcessManagementLoader } from './parts/TuitionContinuityProcessManagementLoader';

export default function TuitionContinuityProcessManagement() {
  const { t } = useTranslation();
  const prefix = 'tuitionContinuityProcessManagement';

  const texts = {
    period: t(`${prefix}.period`),
    school: t(`${prefix}.school`),
  };

  return (
    <div className="student-grades-closure mx-3">
      <Card className="p-4">
        <BaseLoader>
          {({ data }) => (
            <FilterList {...data}>
              {(periodId: number, campusId?: number) => (
                <TuitionContinuityProcessManagementLoader
                  periodId={periodId}
                  campusId={campusId}
                >
                  {({
                    studyPlanVersionOffers,
                    schoolOption,
                    onChangeSchool,
                  }) => (
                    <>
                      <Col xs={12} md={4} lg={4}>
                        <OutlinedSelect
                          name="selection-school"
                          label={texts.school}
                          isClearable
                          options={schoolOption}
                          onChange={onChangeSchool}
                          placeholder="Todas las facultades"
                        />
                      </Col>

                      <Col md={12}>
                        <TuitionContinuityProcessManagementList
                          periodId={periodId}
                          data={studyPlanVersionOffers}
                        />
                      </Col>
                    </>
                  )}
                </TuitionContinuityProcessManagementLoader>
              )}
            </FilterList>
          )}
        </BaseLoader>
      </Card>
    </div>
  );
}
